import {
  darkgreen,
  gray600,
  gray_border,
  yacare_border,
  green100,
  blue600,
  blue100,
} from '@/components/Common/styles/commonColors';
import { EN_TITLE_COLOR, EN_TITLE_WEIGHT } from '@yanolja-rnd/cx-joy-sdm/dist/sapporo/constant/enum/text/index';
import { IDesignedString } from '@/models/Common/interfaces/ICommonDomesticPlace';
import { CSSProperties } from 'react';

const COLOR_LIST: Partial<Record<EN_TITLE_COLOR, string>> = {
  pink: blue600,
  gray_700: gray600,
  dark_green: darkgreen,
};

const BORDER_COLOR_LIST: Record<string, string> = {
  pink: blue100,
  gray: gray_border,
  dark_green: yacare_border,
  yagreen: green100,
};

const getColor = (colorValue: string | null): string => {
  if (!colorValue) return '';

  return colorValue in COLOR_LIST ? COLOR_LIST[colorValue] : colorValue;
};

const getBorderColor = (colorValue: string | null): string => {
  if (!colorValue) return '';

  return colorValue in BORDER_COLOR_LIST ? BORDER_COLOR_LIST[colorValue] : colorValue;
};

export const getJoyDesignedStringStyle = (designedString: IDesignedString): CSSProperties => {
  const color = getColor(designedString.color);
  const backgroundColor = getColor(designedString.background);
  const borderColor = getBorderColor(designedString.color);
  const fontWeight = Number.isNaN(Number(designedString.weight))
    ? Number(EN_TITLE_WEIGHT[designedString.weight])
    : Number(designedString.weight);
  const fontSize = designedString.size ? `${designedString.size / 10}rem` : '';

  return {
    color,
    backgroundColor,
    borderColor,
    fontWeight,
    fontSize,
  };
};
